import { render, staticRenderFns } from "./illustrate.vue?vue&type=template&id=0c242690&scoped=true&"
import script from "./illustrate.vue?vue&type=script&lang=ts&"
export * from "./illustrate.vue?vue&type=script&lang=ts&"
import style0 from "./illustrate.vue?vue&type=style&index=0&id=0c242690&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c242690",
  null
  
)

export default component.exports